module.exports = __webpack_public_path__ + "static/media/click.efdadc4f.mp3";